import { Container, Typography, Grid, Card, CardContent, CardMedia, Box } from '@mui/material';

import Mikias from "../../images/mikias.jpg";
import Hana from "../../images/hana.jpg";
import Merry from "../../images/meron.jpg";
import Bisrat from "../../images/bisrat.jpg";
import Yordanos from "../../images/yordi.jpg";

const teamMembers = [
    {
        name: 'Bisrat Tegegn',
        role: 'Chief Executive Officer',
        imageUrl: Bisrat,
        description: 'Bisrat brings over six years of technical leadership and product strategy expertise to his role as CEO. Combining deep full-stack engineering expertise with executive vision, he leads the company\'s overall strategic direction, driving growth and operational excellence across all platforms.',
    },
    {
        name: 'Mikias Hiluf',
        role: 'Co-Founder & Chief Strategy Officer',
        imageUrl: Mikias,
        description: 'As a co-founder and strategic architect, Mikias guides long-term organizational strategy and sustainable expansion. Leveraging his background in structural design and systems planning, he focuses on high-level growth, partnership development, and keeping our vision resilient and forward-thinking.',
    },
    {
        name: 'Meron Wendwesen',
        role: 'Chief Operations Officer',
        imageUrl: Merry,
        description: 'Meron is a highly proficient administrative and logistics professional with extensive experience in managing complex warehouse operations, property management, and inventory control. Her meticulous approach ensures the efficient and secure flow of goods, directly supporting the operational backbone and supply chain integrity of the organization.',
    },
    {
        name: 'Yordanos Melaku',
        role: 'Chief Technology Officer',
        imageUrl: Yordanos, // Assumes you have imported or defined `Yordanos` image asset
        description: 'Yordanos leads our engineering strategy and technical roadmap, having architected the core codebase since the company\'s inception. She oversees our scalable Firebase backend and Cloud Functions, while driving cross-platform application development across Flutter for Android and Web.',
    },
    {
        name: 'Hana Endashaw',
        role: 'Chief Impact Officer',
        imageUrl: Hana,
        description: 'Hana is a seasoned Monitoring, Evaluation, Accountability, and Learning (MEAL) expert with a proven track record in designing data-driven systems and leading complex surveys for major humanitarian and food security programs. She excels at transforming quantitative and qualitative data into actionable insights and dashboards to guide strategic decision-making and ensure program impact.',
    },
];

const TeamSection = () => {
    return (
        <Box sx={{ 
            py: { xs: 6, sm: 8, md: 10 }, 
            bgcolor: '#f7f9fc' 
        }}>
            <Container maxWidth="lg">
                <Typography 
                    component="h2" 
                    variant="h3" 
                    align="center" 
                    sx={{ 
                        mb: { xs: 4, sm: 6, md: 8 }, 
                        fontWeight: 600,
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
                    }}
                >
                    Meet Our Leadership
                </Typography>
                
                <Grid 
                    container 
                    spacing={{ xs: 3, sm: 4 }}
                    justifyContent="center"
                >
                    {teamMembers.map((member) => (
                        <Grid 
                            item 
                            key={member.name} 
                            xs={12} 
                            sm={6} 
                            md={4} 
                            lg={3}
                            sx={{ 
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <Card 
                                sx={{
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    height: '100%',
                                    maxWidth: 360,
                                    width: '100%',
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        transform: 'translateY(-6px)',
                                        boxShadow: '0 12px 30px rgba(0,0,0,0.12)',
                                        '& .MuiCardMedia-root': {
                                            transform: 'scale(1.03)',
                                        }
                                    }
                                }}
                            >
                                <Box sx={{ overflow: 'hidden', width: '100%' }}>
                                    <CardMedia
                                        component="img"
                                        image={member.imageUrl}
                                        alt={member.name}
                                        sx={{
                                            aspectRatio: '747 / 942',
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'cover',
                                            objectPosition: 'top center',
                                            transition: 'transform 0.5s ease-in-out'
                                        }}
                                    />
                                </Box>
                                <CardContent 
                                    sx={{ 
                                        textAlign: 'center', 
                                        p: { xs: 2.5, sm: 3 }, 
                                        flexGrow: 1,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    <Typography 
                                        gutterBottom 
                                        variant="h5" 
                                        component="div" 
                                        fontWeight="600"
                                        sx={{ fontSize: { xs: '1.2rem', sm: '1.35rem' } }}
                                    >
                                        {member.name}
                                    </Typography>
                                    <Typography 
                                        variant="subtitle1" 
                                        color="primary.main" 
                                        fontWeight="600"
                                        sx={{ mb: 1.5, fontSize: '0.95rem' }}
                                    >
                                        {member.role}
                                    </Typography>
                                    <Typography 
                                        variant="body2" 
                                        color="text.secondary" 
                                        sx={{ 
                                            mt: 'auto',
                                            lineHeight: 1.6,
                                            fontSize: '0.875rem'
                                        }}
                                    >
                                        {member.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default TeamSection;